import moment from 'moment';

export default {
    name: 'AddUser',
    created() {
        this.GetInfo();
    },
    components: {
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            state: 0,
            Info: [],
            Info1: [],
            
        };
    },
    methods: {
      

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            this.$blockUI.Start();
            this.$http.GetRequiment(this.pageNo, this.pageSize,)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.devices;
                    this.Info1 = response.data.filters;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },


        

    }
}
